// extracted by mini-css-extract-plugin
export default {"banner":"Home_banner__ihvBr","titulliPershkrim":"Home_titulliPershkrim__om3dA","artikujt":"Home_artikujt__Zvwzw","titulliArtikuj":"Home_titulliArtikuj__8tnsu"};